import { TableController } from '../class/_tableController.js';

export const tableControl = () => {
  const tables = document.querySelectorAll( '.p-search-table' );

  tables.forEach( table => {
    const sortButton = table.querySelectorAll( '[data-sort-key]' ) || false;
    if ( ! sortButton.length ) return false;
    const tableController = new TableController( table );
    sortButton.forEach( button => {
      button.addEventListener( 'click', function () {
        const key = button.getAttribute( 'data-sort-key' );
        const icon = button.querySelector( '.sort' );

        sortButton.forEach( item => {
          if ( item !== button ) {
            const icon = item.querySelector( '.sort' );
            icon.classList.remove( 'is--DESC' );
            icon.classList.remove( 'is--ASC' );
          }
        } );

        if ( ! icon.classList.contains( 'is--DESC' ) && ! icon.classList.contains( 'is--ASC' ) ) {
          icon.classList.add( 'is--DESC' );
          tableController.sortDESC( key );

        } else if ( icon.classList.contains( 'is--DESC' ) ) {
          icon.classList.remove( 'is--DESC' );
          icon.classList.add( 'is--ASC' );
          tableController.sortASC( key );

        } else if ( icon.classList.contains( 'is--ASC' ) ) {
          icon.classList.remove( 'is--DESC' );
          icon.classList.remove( 'is--ASC' );
          tableController.sortDefault();
        }
      } );
    } );
  } );
}
